// One button model used everywhere in the grid (bulk bar, parent 3-dots, child 3-dots, header icons):
//   button = { key, label, variant, color, icon, ariaLabel, visible?(ctx), disabled?(ctx), disabledReason?(ctx), onClick(ctx) }
// `ctx` is supplied by the caller and carries whatever that surface knows: { subject, row?, child?, selected, clearSelection }.

export const visibleButtons = (buttons = [], ctx) => buttons.filter((b) => (b.visible ? b.visible(ctx) : true));

// Map to the RowMenu action shape ([{ label, onClick, color, disabled, disabledReason }]).
export const toMenuActions = (buttons = [], ctx) =>
    visibleButtons(buttons, ctx).map((b) => ({
        label: b.label,
        color: b.color,
        disabled: b.disabled ? b.disabled(ctx) : false,
        disabledReason: b.disabledReason ? b.disabledReason(ctx) : '',
        onClick: () => b.onClick(ctx),
    }));

// Map to the BulkActions button shape ([{ label, variant, color, onClick, disabled, disabledReason }]).
export const toBarButtons = (buttons = [], ctx) =>
    visibleButtons(buttons, ctx).map((b) => ({
        label: b.label,
        variant: b.variant,
        color: b.color,
        disabled: b.disabled ? b.disabled(ctx) : false,
        disabledReason: b.disabledReason ? b.disabledReason(ctx) : '',
        onClick: () => b.onClick(ctx),
    }));
